var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "m-subheader" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "ul",
            { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
            [
              _c(
                "li",
                { staticClass: "m-nav__item" },
                [
                  _c("router-link", { attrs: { to: { name: "home" } } }, [
                    _c("span", { staticClass: "m-nav__link-text" }, [
                      _c("i", { staticClass: "m-nav__link-icon la la-home" })
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__separator" }, [
                _vm._v("\n\t\t  \t  \t\t>\n\t\t  \t  \t")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__item" }, [
                _c("span", { staticClass: "m-nav__link-text" }, [
                  _vm._v(
                    "\n\t\t  \t  \t\t\t\t" +
                      _vm._s(
                        _vm._f("titleize")(
                          _vm._f("translate")("property_administration")
                        )
                      ) +
                      "\n\t\t  \t  \t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__separator" }, [
                _vm._v("\n\t\t  \t  \t\t>\n\t\t  \t  \t")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__item" }, [
                _c("span", { staticClass: "m-nav__link-text" }, [
                  _vm._v(
                    "\n\t\t  \t  \t\t\t" +
                      _vm._s(
                        _vm._f("titleize")(_vm._f("translate")("reports"))
                      ) +
                      "\n\t\t  \t  \t\t"
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "m-content", attrs: { id: "content" } }, [
      _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
        _c("div", { staticClass: "m-portlet__head" }, [
          _c("div", { staticClass: "m-portlet__head-caption" }, [
            _c("div", { staticClass: "m-portlet__head-title" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("h3", { staticClass: "m-portlet__head-text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm._f("capitalize")(_vm._f("translate")("reports"))
                    ) +
                    "\n              "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "m-portlet__body" },
          [
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  class: [
                    { "has-danger": _vm.errors.has("report_type") },
                    "col-lg-3"
                  ]
                },
                [
                  _c("label", { attrs: { for: "report_type" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("report_type"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.report_type,
                          expression: "report_type"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      class: {
                        "form-control": true,
                        error: _vm.errors.has("report_type")
                      },
                      attrs: { name: "report_type", id: "report_type" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.report_type = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(_vm._s(_vm._f("capitalize")("select_an_option")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.report_types, function(report_type, key) {
                        return _c(
                          "option",
                          {
                            key: key,
                            attrs: {
                              disabled:
                                (!_vm.is_property_admin &&
                                  (report_type.value === 9 ||
                                    report_type.value === 10)) ||
                                (_vm.shard.profile_id === 2 &&
                                  (report_type.value === 1 ||
                                    report_type.value === 3 ||
                                    report_type.value === 5 ||
                                    report_type.value === 7 ||
                                    report_type.value === 9 ||
                                    report_type.value === 10)) ||
                                (report_type.value === 15 &&
                                  !_vm.userData.payment_user)
                            },
                            domProps: { value: report_type.value }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")(report_type.name)
                                )
                              )
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("report_type"),
                          expression: "errors.has('report_type')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.errors.first("report_type")) + " "
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.report_type === 1
              ? _c("present-personal", {
                  attrs: { report_type: _vm.report_type }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 2
              ? _c("authorized-personal", {
                  attrs: { report_type: _vm.report_type }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 3
              ? _c("staff-expired", { attrs: { report_type: _vm.report_type } })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 4
              ? _c("historical-access", {
                  attrs: { report_type: _vm.report_type }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 5
              ? _c("exception", { attrs: { report_type: _vm.report_type } })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 6
              ? _c("assist", { attrs: { report_type: _vm.report_type } })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 7
              ? _c("authorized-by-person", {
                  attrs: { report_type: _vm.report_type }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 8
              ? _c("use-of-system", { attrs: { report_type: _vm.report_type } })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 9
              ? _c("public-vehicles", {
                  attrs: { report_type: _vm.report_type }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 10
              ? _c("forced-access", { attrs: { report_type: _vm.report_type } })
              : _vm._e(),
            _vm._v(" "),
            _vm.report_type === 15
              ? _c("system-charges", {
                  attrs: { report_type: _vm.report_type }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon" }, [
      _c("i", { staticClass: "flaticon-suitcase" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head-tools" }, [
      _c("ul", { staticClass: "m-portlet__nav" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8fa964e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8fa964e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/reports/All.vue
// module id = 738
// module chunks = 0 1 4